import { ComponentsAddressMapper } from "@omni/mappers/customer/address.mapper";
import { CloudCustomerOrderAddress } from "@omni/types/api/customer/cloud/orderAddress.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";

import { CustomerAddress } from "@/components/Address/Address/address.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const OrderDeliveryDetailsBlock = ({
    address
}: {
    address: CloudCustomerOrderAddress;
}) => {
    const { t } = useGranite();

    return (
        <div className="mb-4">
            <h4>{t("orderOverview.title.deliveryAddress")}</h4>
            <CustomerAddress
                address={ComponentsAddressMapper.fromCloudCustomerOrder(
                    address
                )}
                addressType={AddressType.Delivery}
            />
        </div>
    );
};

export default OrderDeliveryDetailsBlock;
